<div class="relative">
  <div class="flex gap-3 items-center" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu">
    <ig-expand-indicator *ngIf="itinerary" aria-label="open"
      [matTooltip]="itinerary ? 'Update itinerary' : ''"></ig-expand-indicator>
    <span class="text-2xl !text-gray-200 font-semibold cursor-pointer shadow-2xl ig-color-picker-shadow">
      {{ itinerary ? "" : "Create a New Itinerary" }}
    </span>
  </div>

  <mat-menu #menu="matMenu" class="ig-iti-create !rounded-2xl px-6 py-2 {{ menuClass }}">
    <div class="flex justify-between items-center pb-3">
      <p class="text-xl font-semibold text-gray-600" igClickStopPropagation>
        {{ itinerary ? "Update Itinerary" : "Create a New Itinerary" }}
      </p>
      <mat-icon
        class="text-gray-600 text-[14px] border-[1px] border-gray-600 flex items-center justify-center !w-4 !h-4 rounded-full cursor-pointer">
        close
      </mat-icon>
    </div>

    <div class="max-h-[50vh] overflow-auto pr-3" igClickStopPropagation>
      <div class="pt-6">
        <ig-field [control]="form.get('title')" (keydown.tab)="$event.stopPropagation()" label="Title" [maxlength]="100"
          icon="title" igClickStopPropagation></ig-field>
      </div>
      <div class="">
        <ig-field [control]="form.get('description')" mode="textarea" (keydown.tab)="$event.stopPropagation()"
          label="Description" [maxlength]="600" [class.ig-textarea-has-content]="!!form.get('description').value"
          icon="more_horiz" igClickStopPropagation></ig-field>
      </div>
      <div class="">
        <ig-tab-image-link-file-selector #imgUploader [compressWidth]="1800" (onImageUploaded)="onImageUploaded($event)"
          [useUploadButton]="false" [initialImg]="itinerary?.image"></ig-tab-image-link-file-selector>

        <b class=" text-gray-600 mt-8 font-bold block">Add Itinerary Info</b>
        <div class="text-xs text-gray-500 mb-3">Provide additional details about the itinerary. This info will appear in
          the
          frontend widget alongside distance and time. Suggested details: estimated expenses, child-friendly itinerary,
          pet-friendly attractions, accessibility notes, best time to visit, entry fees, recommended attire and more.
        </div>
        @for (control of formArray; track control; let i = $index) {
        <div class="flex gap-3 w-full relative items-center" igClickStopPropagation>
          <mat-form-field appearance="outline" class="w-4/5" igClickStopPropagation>
            <mat-label>Info</mat-label>
            <input matInput (focus)="onFocus()" [formControl]="control['controls']['field']" igClickStopPropagation
              (keydown.tab)="$event.stopPropagation()" />
          </mat-form-field>

          <mat-icon class="text-blue-400 cursor-pointer font-lg -translate-y-3"
            (click)="i > 0 ? removeFields(i) : addFields()" igClickStopPropagation>
            {{ i > 0 ? "do_not_disturb_on" : "add_circle" }}
          </mat-icon>
        </div>
        }
      </div>

      <div *ngIf="itinerary" class="mb-4" igClickStopPropagation>
        <div class="mb-4">
          <b class="text-gray-600">Status</b>
          <mat-radio-group class="flex gap-3" aria-label="Select an option" [(ngModel)]="itinerary.isActive"
            igClickStopPropagation>
            <mat-radio-button [value]="false" class="">Not Published</mat-radio-button>
            <mat-radio-button [value]="true">Published</mat-radio-button>
          </mat-radio-group>

          <!--        <mat-button-toggle-group class="w-full" name="Published" aria-label="Published"--->
          <!--                                 (change)="publishChange($event)" igClickStopPropagation>-->
          <!--          <mat-button-toggle value="false" [checked]="!itinerary.isActive" igClickStopPropagation>Not published-->
          <!--          </mat-button-toggle>-->
          <!--          <mat-button-toggle value="true" [checked]="itinerary.isActive" igClickStopPropagation>Published-->
          <!--          </mat-button-toggle>-->
          <!--        </mat-button-toggle-group>-->
        </div>
        <div class="mb-4" igClickStopPropagation>
          <b class="text-gray-600">Default Travel Mode</b>
          <mat-radio-group class="flex gap-3" aria-label="Select an option"
            [(ngModel)]="itinerary.defaultTravelMode.mode">
            <mat-radio-button [value]="'DRIVING'">Driving</mat-radio-button>
            <mat-radio-button [value]="'BICYCLING'">Cycling</mat-radio-button>
            <mat-radio-button [value]="'WALKING'">Walking</mat-radio-button>
            <!--            <mat-radio-button [value]="'TRANSIT'">Transit</mat-radio-button>-->
          </mat-radio-group>
          <mat-checkbox [(ngModel)]="itinerary.defaultTravelMode.canChange">
            Allow users to view other travel modes</mat-checkbox>
        </div>
        <div class="mb-4 relative" igClickStopPropagation>
          <b class="text-gray-600 block">Release and Expiry Date</b>
          <p class="text-sm text-gray-500 block !mb-2">{{
            timeService.getTZNameByFormatter(
            frontendSettings.customSettings.timezoneFormatter
            )
            }}</p>
          <div class="absolute top-6 right-0 cursor-pointer bg-blue-400 text-white px-2 py-0.5 rounded text-xs"
            (click)="clearDateRange()">clear</div>
          <ig-date-time-picker #releaseDatePicker [startFormControl]="form.get('releaseDate')"
            [endFormControl]="form.get('expiryDate')" class="w-[93%]" mode="itinerary"
            [timezoneFormatter]="frontendSettings.customSettings.timezoneFormatter"></ig-date-time-picker>
          <p *ngIf="form.get('releaseDate').value || form.get('expiryDate').value"
            class="text-xs text-gray-500 block -translate-y-2.5">
            You have set release or expiry date, please notice the status of the itinerary.</p>
        </div>
      </div>
    </div>

    <div class="mt-3 mb-1" igClickStopPropagation>
      <ig-button cls="w-full" (trigger)="submit($event, menuTrigger)" [isAsync]="true" [successText]="
          itinerary
            ? 'Itinerary information updated!'
            : 'Itinerary created successfully!'
        " igClickStopPropagation>{{ itinerary ? "Update" : "Create" }}
      </ig-button>
    </div>
  </mat-menu>
</div>